<template>
    <div class="white-padding-rem card">
        <div class="relativePos">
            <p class="chartTitle">Top 6 Station Summary</p>
            <router-link to="/allStationChartsSummary"><a class="SeeAllLink">SEE ALL</a></router-link>
            <div id="chart" />
            <div v-if="LocationChartsResult" id="chartSummary">
                <table>
                    <tr>
                        <td colspan="2" class="tableTitle">Active</td>
                    </tr>
                    <tr>
                        <td class="tableInfoLeft"><div class="legendTypeSqrt programmeBG" />Programme</td>
                        <td class="tableInfoRight">{{ LocationChartsResult.totalActive.Programme }}</td>
                    </tr>
                    <tr>
                        <td class="tableInfoLeft"><div class="legendTypeSqrt trialBG" />Trial</td>
                        <td class="tableInfoRight">{{ LocationChartsResult.totalActive.Trial }}</td>
                    </tr>
                    <tr>
                        <td class="tableInfoLeft"><div class="legendTypeSqrt progenyBG" />Progeny</td>
                        <td class="tableInfoRight">{{ LocationChartsResult.totalActive.Progeny }}</td>
                    </tr>
                    <tr>
                        <td class="tableInfoLeft"><div class="legendTypeSqrt palmBG" />Palm</td>
                        <td class="tableInfoRight">{{ LocationChartsResult.totalActive.Palm }}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
var mainBlue = getComputedStyle(document.documentElement).getPropertyValue("--main-color-blue"); 
var mainBlueOpacity = getComputedStyle(document.documentElement).getPropertyValue("--main-color-blue-with-opacity"); 

var mainPurple = getComputedStyle(document.documentElement).getPropertyValue("--main-color-purple"); 
var mainPurpleOpacity = getComputedStyle(document.documentElement).getPropertyValue("--main-color-purple-with-opacity"); 

var mainOrange = getComputedStyle(document.documentElement).getPropertyValue("--main-color-orange"); 
var mainOrangeOpacity = getComputedStyle(document.documentElement).getPropertyValue("--main-color-orange-with-opacity"); 

var mainGrey = getComputedStyle(document.documentElement).getPropertyValue("--main-color-grey"); 
var mainGreyOpacity = getComputedStyle(document.documentElement).getPropertyValue("--main-color-grey-with-opacity"); 

export default {

    name: "SummaryStackedBarCharts",

    data () {
        return {
    	pattern: [ mainBlueOpacity, mainBlue, mainPurpleOpacity, mainPurple, mainOrangeOpacity, mainOrange, mainGreyOpacity, mainGrey],
            LocationChartsResult: null,
        };
    },
    mounted() {
        this.getChartData();
    },
    methods: {
  	drawChart() {
            var self = this;
  		var chart = c3.generate({
  		    data: {
  		    	  x: "stationName",
                    columns: self.LocationChartsResult.columns,
                    groups: self.LocationChartsResult.groups,
  		        type: "bar",
                    order: null,
                    // labels: {
                    //     format: function(value, id, i, j){
                    //         var result;
                    //         switch (id) {
                    //           case 'Palm Inactive':
                    //             result = value*1000;
                    //             break;
                    //           case 'Palm Active':
                    //             result = value*1000;
                    //             break;
                    //           case 'Progeny Inactive':
                    //             result = value*100;
                    //             break;
                    //           case 'Progeny Active':
                    //             result = value*100;
                    //             break;
                    //           default: 
                    //             result = value;
                    //         }
                    //         return result;
                    //     }
                    // }
  		    },
                tooltip: {
                    format: {
                        name: function (name, ratio, id, index) { return name; },
                        value: function (value, ratio, id) {
                            var result;
                            switch (id) {
                            case "Palm Inactive":
                                result = value + " ( '000 ) ";
                                break;
                            case "Palm Active":
                                result = value + " ( '000 ) ";
                                break;
                            case "Progeny Inactive":
                                result = value + " ( '00 ) ";
                                break;
                            case "Progeny Active":
                                result = value + " ( '00 ) ";
                                break;
                            default: 
                                result = value;
                            }
                            return result;
                        }
                    }
                },
  		    color: {
  		        pattern: this.pattern,
                },
                size: {
  		        height: 240,
  		    },
  		    axis: {
  		        x: {
  		            type: "category"
  		        }
  		    },
  		    grid: {
  		      y: {
  		        show: true
  		      }
  		    },
  		});
  	},
        getChartData() {
            var self = this;
            axios({
                method: "GET",
                url: "Location/GetTrialLocationChart",
                params: {
                    numberOfLocations: 6,
                }
            })
                .then(function (response) {
                    self.LocationChartsResult = response.data.result;
                    self.$nextTick(function() {
          
                        setTimeout(function() { self.drawChart(); }, 100);
                    });
                });
        }
    }
};
</script>

<style lang="css" scoped>
.chartTitle{
  padding: 0.5rem; 
  margin-bottom: 0;
  font-weight: 600;
  text-align: center;
}
.SeeAllLink{
  position: absolute;
  right: 1rem;
  top: 0;
  padding: 8px;
  margin: 0;
}
.SeeAllLink:hover{
  cursor: pointer;
  color: #314c60 !important;
}
#chartSummary{
  position: absolute;
  right: 1rem;
  top: 3.5rem;
  padding: 12px 8px;
  background-color: #fff;
  border: 1px solid #eee;
}
table .tableInfoLeft{
  padding: 0 10px;
  color: #656565;
  font-size: 11px;
}
table .tableInfoRight{
  padding: 0 10px;
  text-align: right;
  color: #848484;
  font-size: 11px;
}
.tableTitle{
  padding: 0 10px;
  font-weight: 600;
  color: #848484;
  font-size: 12px;
}
.legendTypeSqrt{
  display: inline-block;
  width: 6px;
  height: 6px;
  vertical-align: middle;
  margin-right: 8px;
}
.programmeBG{
  background-color: var(--main-color-blue);
}
.trialBG{
  background-color: var(--main-color-purple);
}
.progenyBG{
  background-color: var(--main-color-orange);
}
.palmBG{
  background-color: var(--main-color-grey);
}

</style>


// WEBPACK FOOTER //
// src/components/Dashboard/SummaryStackedBarCharts.vue